import '../styles/Footer.css';

const Footer = () => {
    return (
        <div className="Footer">
        Copyright © Q's Counseling PLLC. 2025
        </div>
    )
}

export default Footer;